import React from 'react'
import './About.css'

export default function About() {
  return (
    <div id="About">
        <div id="About-head">
            <div id="title">About</div>

            <p >Here you will find more information about me, what I do, and my current skills mostly in terms of programming and technology</p>
        </div>
        <div id="About-body">
            <div id='About-body-left' className="box">
                <div id="side-heading">Get to Know me   </div>
                <div>
                I'm a Frontend Web Developer building the Front-end of Websites and Web Applications that leads to the success of the overall product. Check out some of my work in the Projects section.

                I also like sharing content related to the stuff that I have learned over the years in Web Development so it can help other people of the Dev Community. Feel free to Connect or Follow me on my Linkedin where I post useful content related to Web Development and Programming

                I'm open to Job opportunities where I can contribute, learn and grow. If you have a good opportunity that matches my skills and experience then don't hesitate to contact me.

                </div>
            </div>
            <div id='About-body-right' className="box">
                <div id="side-heading">My Skills  </div>
                <div id='skills'>
                    <div id='skill'>C</div>
                    <div id='skill'>Python</div>
                    <div id='skill'>java</div>
                    <div id='skill'>Linux</div>
                    <div id='skill'>AngularJS</div>
                    <div id='skill'>ReactJS</div>
                    <div id='skill'>JS</div>
                    <div id='skill'>HTML</div>
                    <div id='skill'>CSS</div>
                    <div id='skill'>WireShark</div>
                    <div id='skill'>Git</div>
                    <div id='skill'>SQL</div>
                    <div id='skill'>MangoDB</div>
                    <div id='skill'>BlockChain</div>

                </div>
            </div>
        </div>
    </div>
  )
}
